import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
const attrName = 'data-overflow-hidden-count';
const getOverflowHiddenCount = (): number => {
  const overflowHiddenCountAttrStr = document.body.getAttribute(attrName);
  return overflowHiddenCountAttrStr === null ? 0 : parseInt(overflowHiddenCountAttrStr, 10);
};
const incrementOrDecrementCountAndUpdateStyle = (shouldIncrement: boolean): void => {
  const overflowHiddenCountBefore = getOverflowHiddenCount();
  const overflowHiddenCountNow = Math.max(0, overflowHiddenCountBefore + (shouldIncrement ? 1 : -1));
  document.body.setAttribute(attrName, overflowHiddenCountNow.toString());
  const wasHiddenBefore = overflowHiddenCountBefore > 0;
  const isHidden = overflowHiddenCountNow > 0;
  if (wasHiddenBefore !== isHidden) {
    document.body.style.overflow = isHidden ? 'hidden' : 'auto';
  }
};
const useBodyOverflowHidden = shouldSetBodyOverflowHidden => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== shouldSetBodyOverflowHidden) {
    t0 = () => {
      if (shouldSetBodyOverflowHidden) {
        incrementOrDecrementCountAndUpdateStyle(true);
      }
      return () => {
        if (shouldSetBodyOverflowHidden) {
          incrementOrDecrementCountAndUpdateStyle(false);
        }
      };
    };
    t1 = [shouldSetBodyOverflowHidden];
    $[0] = shouldSetBodyOverflowHidden;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useBodyOverflowHidden;